import {
  home_hero_default
} from "./chunk-TAEOV7ZR.js";

// src/layouts/home-hero/index.ts
var home_hero_default2 = home_hero_default;

export {
  home_hero_default2 as home_hero_default
};
